import { gql } from '@apollo/client';

export const getRecordSeriesLink = gql`
mutation RecordSeriesLink($deviceId: ID!
    $profileId: ID!
    $seriesLinkId: ID!
    $appId: AppId! ) {
    recordSeriesLink(
        deviceId: $deviceId
        profileId: $profileId
        seriesLinkId: $seriesLinkId
        appId: $appId
    ) {
        ... on SubscriptionNeeded {
            subscriptions {
                id
                title
                __typename
            }
            __typename
        }
        ... on DeviceNotRecordCapable {
            device {
                id
            }
            __typename
        }
        ... on QueuedRecordingSet {
            version
            recordRequests {
                __typename
            }
            __typename
        }
        __typename
    }
}`;